import { CasTextField } from '..';
import { ICasTextField } from './CasTextField';

export default function CasMultilineTextField(props: ICasTextField) {
  return <CasTextField multiline minRows={2} {...props} />;
}
